import React, { useState } from 'react';
// import Chart from 'chart.js/auto';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart } from 'primereact/chart';
// Chart.register(ChartDataLabels);
export const LeaveYearChart = ({ data, options }) => {
    return (
        <div style={{ width: '100%', height: '100%' }}>
            <Chart type="line" data={data} options={options} />
        </div>
    )
}
